<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <img src="@/assets/image/LOGO.png" alt="博洛克供应链" />
        <p>
          安徽博洛克供应链科技股份有限公司成立于2020年，是一家“互联网+运贸融”一体化平台型公司，持续为产业链上下游提供数字化供应链服务。
        </p>
      </div>

      <div class="footer-links">
        <h3>产品服务</h3>
        <router-link to="/">首页</router-link>
        <router-link to="/AppSolution">应用方案</router-link>
      </div>

      <div class="footer-qrcodes">
        <h3>关注我们</h3>
        <div class="qrcode-row">
          <figure>
            <img src="@/assets/image/微信二维码.png" alt="微信二维码" />
            <figcaption>微信咨询</figcaption>
          </figure>
          <figure>
            <img src="@/assets/image/公众号.png" alt="公众号二维码" />
            <figcaption>公众号</figcaption>
          </figure>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <span>© 2020-2026 block2025.com 安徽博洛克供应链科技股份有限公司</span>
      <el-link :underline="false" href="https://beian.miit.gov.cn/" target="_blank">
        互联网ICP备案：皖ICP备20009156号-1
      </el-link>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="less" scoped>
.site-footer {
  color: #d0d5dd;
  background: #101828;
}

.footer-inner {
  display: grid;
  grid-template-columns: minmax(260px, 1.2fr) minmax(160px, 0.5fr) minmax(260px, 0.8fr);
  gap: clamp(32px, 6vw, 80px);
  padding: 58px clamp(24px, 6vw, 96px);
}

.footer-brand {
  max-width: 560px;

  img {
    display: block;
    width: 168px;
    height: auto;
    padding: 8px 10px;
    background: #fff;
    border-radius: 6px;
  }

  p {
    margin-top: 22px;
    color: #98a2b3;
    font-size: 15px;
    line-height: 1.8;
  }
}

.footer-links,
.footer-qrcodes {
  h3 {
    color: #fff;
    font-size: 16px;
    font-weight: 800;
  }
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 14px;

  a {
    color: #98a2b3;
    font-size: 15px;

    &:hover {
      color: #fff;
    }
  }
}

.qrcode-row {
  display: flex;
  gap: 18px;
  margin-top: 18px;

  figure {
    margin: 0;
  }

  img {
    display: block;
    width: 104px;
    height: 104px;
    object-fit: cover;
    background: #fff;
    border-radius: 6px;
  }

  figcaption {
    margin-top: 10px;
    color: #98a2b3;
    font-size: 13px;
    text-align: center;
  }
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px clamp(24px, 6vw, 96px);
  color: #98a2b3;
  font-size: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  :deep(.el-link) {
    color: #98a2b3;
    font-size: 14px;

    &:hover {
      color: #fff;
    }
  }
}

@media screen and (max-width: 900px) {
  .footer-inner {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media screen and (max-width: 640px) {
  .footer-inner,
  .footer-bottom {
    padding-left: 18px;
    padding-right: 18px;
  }

  .qrcode-row {
    flex-wrap: wrap;
  }
}
</style>
